import React, {useEffect, useState} from "react";
import {faFileExport} from "@fortawesome/free-solid-svg-icons/faFileExport";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {post,excelFileDownload} from "../../api";
import FileExportIcon from "./FileExportIcon";
import {isSpinnerShowing, spinnerOff, spinnerOn} from "../Spinner";

export default (function FileExport(props){

    let project = {};

    function getProjectStatus(){
        const {tabView} = props;

        if(tabView){
            //let pathname = location.pathname;
            if(tabView) {
                if (tabView.includes("upcoming")) {
                    return "U";
                } else if (tabView.includes("development")) {
                    return "D";
                } else if (tabView.includes("release")) {
                    return "R";
                } else if (tabView.includes("active")) {
                    return "A";
                } else if (tabView.includes("closed")) {
                    return "C";
                } else if (tabView.includes("checklist")) {
                    return "N";
                } else if (tabView.includes("all")) {
                    return "";
                }else{
                    return null;
                }

            }
        }

    }
    async function excelDownload(){
            let projectStatus = getProjectStatus();
            if(projectStatus != null ) {
                spinnerOn();
                project.projectStatus = projectStatus;
                await excelFileDownload(project,projectStatus);
                spinnerOff();
            }
    }

    return(
        <FileExportIcon props={props} onClick={() =>excelDownload()}/>
    )

})